import React, { useState } from "react";
import {
  Calendar,
  Clock,
  User,
  Box,
  Sparkles,
  Star,
  Moon,
  Sun,
  MapPin,
  CheckCircle2,
  ChevronRight,
  ChevronLeft,
} from "lucide-react";

const App = () => {
  const [step, setStep] = useState(1);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedEquip, setSelectedEquip] = useState([]);

  // 已預約資料
  const bookedSlots = [
    { room: "木星", date: "2026-02-01", start: "13:00", end: "16:00" },
    { room: "太陽", date: "2026-02-03", start: "13:30", end: "16:00" },
    { room: "太陽", date: "2026-02-04", start: "13:30", end: "16:00" },
    { room: "太陽", date: "2026-02-05", start: "14:00", end: "15:30" },
    { room: "木星", date: "2026-02-06", start: "14:00", end: "16:00" },
    { room: "太陽", date: "2026-02-06", start: "14:00", end: "15:00" },
    { room: "金星", date: "2026-02-06", start: "14:30", end: "16:00" },
    { room: "木星", date: "2026-02-07", start: "14:00", end: "17:00" },
    { room: "太陽", date: "2026-02-07", start: "14:30", end: "16:00" },
    { room: "太陽", date: "2026-02-10", start: "13:30", end: "16:00" },
    { room: "木星", date: "2026-02-10", start: "14:00", end: "15:30" },
    { room: "太陽", date: "2026-02-11", start: "13:30", end: "16:00" },
    { room: "木星", date: "2026-02-13", start: "14:00", end: "16:00" },
    { room: "太陽", date: "2026-02-13", start: "14:00", end: "15:00" },
    { room: "太陽", date: "2026-02-14", start: "11:30", end: "13:00" },
    { room: "太陽", date: "2026-02-14", start: "14:00", end: "15:30" },
    { room: "金星", date: "2026-02-14", start: "14:00", end: "16:30" },
    { room: "太陽", date: "2026-02-27", start: "13:00", end: "17:00" },
    { room: "太陽", date: "2026-02-28", start: "11:00", end: "17:00" },
    { room: "木星", date: "2026-03-14", start: "14:00", end: "17:00" },
  ];

  const rooms = [
    {
      id: "木星",
      name: "木星",
      capacity: "1-12人",
      desc: "適合講座、會議、交流茶會、手作",
      icon: (
        <div className="w-12 h-12 rounded-full bg-orange-200 flex items-center justify-center text-orange-600 shadow-inner">
          ♃
        </div>
      ),
    },
    {
      id: "海王星",
      name: "海王星",
      capacity: "1-8人",
      desc: "適合瑜伽、美容美體、視聽播放、聲音療育",
      icon: (
        <div className="w-12 h-12 rounded-full bg-blue-200 flex items-center justify-center text-blue-600 shadow-inner">
          ♆
        </div>
      ),
    },
    {
      id: "月亮",
      name: "月亮",
      capacity: "1-4人",
      desc: "適合一對一療育、催眠、占卜",
      icon: <Moon className="w-8 h-8 text-indigo-400" />,
    },
    {
      id: "太陽",
      name: "太陽",
      capacity: "1-12人",
      desc: "適合瑜伽、頌缽、多元分享、講座、攝影棚、寵物溝通",
      icon: <Sun className="w-8 h-8 text-yellow-500" />,
    },
    {
      id: "金星",
      name: "金星",
      capacity: "1-8人",
      desc: "適合品牌分享茶會、聚餐、手作、攝影棚",
      icon: (
        <div className="w-12 h-12 rounded-full bg-pink-200 flex items-center justify-center text-pink-600 shadow-inner">
          ♀
        </div>
      ),
    },
  ];

  const equipments = [
    { id: "mic", name: "麥克風" },
    { id: "projector", name: "投影機" },
    { id: "speaker", name: "藍芽音響" },
    { id: "beautyBed", name: "折疊美容床", limit: ["太陽", "海王星"] },
    { id: "starLight", name: "星空投影燈" },
  ];

  const timeSlots = [];
  for (let h = 11; h <= 19; h++) {
    timeSlots.push(`${h}:00`);
    if (h < 19 || (h === 19 && true)) timeSlots.push(`${h}:30`);
  }

  // 判斷時段是否被預約
  const isTimeOccupied = (room, date, time) => {
    if (!room || !date) return false;
    const dateStr = date.toISOString().split("T")[0];
    const checkTime = time.padStart(5, "0");

    return bookedSlots.some((slot) => {
      if (slot.room === room && slot.date === dateStr) {
        return checkTime >= slot.start && checkTime < slot.end;
      }
      return false;
    });
  };

  const handleBooking = () => {
    if (!name || !phone || !startTime || !endTime) {
      alert("請填寫完整預約資訊");
      return;
    }

    const duration =
      parseInt(endTime.split(":")[0]) * 60 +
      parseInt(endTime.split(":")[1]) -
      (parseInt(startTime.split(":")[0]) * 60 +
        parseInt(startTime.split(":")[1]));

    if (duration < 60) {
      alert("最短起租時間為 1 小時");
      return;
    }

    const msg = `您好，我想預約空間：
【空間】${selectedRoom}
【日期】${selectedDate.toLocaleDateString()}
【時間】${startTime} - ${endTime}
【器材】${selectedEquip.length > 0 ? selectedEquip.join("、") : "無"}
【預約人姓名】${name}
【預約人電話】${phone}`;

    const encodedMsg = encodeURIComponent(msg);
    // ⚠️ 記得把下面的 ID 換成你的 LINE ID
    window.location.href = `https://line.me/R/oaMessage/@766mwgcv/?${encodedMsg}`;
  };

  return (
    <div className="min-h-screen bg-[#FFFBEB] text-slate-800 font-sans relative overflow-hidden pb-12">
      {/* Background Universe Elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none opacity-40">
        <div className="absolute top-10 left-10 w-2 h-2 bg-yellow-400 rounded-full animate-pulse shadow-[0_0_10px_#facc15]"></div>
        <div className="absolute top-40 right-20 w-3 h-3 bg-white rounded-full animate-ping"></div>
        <div className="absolute bottom-20 left-1/4 w-1 h-1 bg-yellow-200 rounded-full animate-bounce"></div>
        <div className="absolute top-1/2 right-10 w-16 h-16 border border-yellow-200 rounded-full opacity-20 rotate-45"></div>
        <div className="absolute -top-10 -left-10 w-40 h-40 bg-yellow-100 rounded-full blur-3xl opacity-50"></div>
      </div>

      {/* Header */}
      <header className="pt-10 pb-6 text-center relative z-10">
        <div className="inline-block p-2 rounded-full bg-white shadow-sm mb-4">
          <Sparkles className="w-6 h-6 text-yellow-500" />
        </div>
        <h1 className="text-3xl font-bold tracking-tight text-yellow-900 mb-2">
          際域 身心靈共享空間
        </h1>
        <p className="text-yellow-700 opacity-80">
          Infinite Universe Shared Space
        </p>
      </header>

      <main className="max-w-xl mx-auto px-5 relative z-10">
        {/* Progress Bar */}
        <div className="flex justify-between mb-8 relative">
          <div className="absolute top-1/2 left-0 w-full h-0.5 bg-yellow-200 -z-10 -translate-y-1/2"></div>
          {[1, 2, 3].map((num) => (
            <div
              key={num}
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-500 ${
                step >= num
                  ? "bg-yellow-400 text-white scale-110 shadow-lg"
                  : "bg-white text-yellow-300 border border-yellow-100"
              }`}
            >
              {num}
            </div>
          ))}
        </div>

        {/* Step 1: Room Selection */}
        {step === 1 && (
          <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <h2 className="text-xl font-semibold flex items-center gap-2 mb-4">
              <MapPin className="w-5 h-5 text-yellow-600" /> 選擇預約空間
            </h2>
            {rooms.map((room) => (
              <button
                key={room.id}
                onClick={() => {
                  setSelectedRoom(room.id);
                  setStep(2);
                }}
                className={`w-full text-left p-4 rounded-3xl transition-all duration-300 border-2 group hover:shadow-xl hover:-translate-y-1 ${
                  selectedRoom === room.id
                    ? "bg-white border-yellow-400 shadow-lg"
                    : "bg-white border-transparent shadow-sm"
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className="shrink-0 transition-transform group-hover:scale-110 duration-500">
                    {room.icon}
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-between items-center mb-1">
                      <h3 className="text-lg font-bold text-slate-800">
                        {room.name}
                      </h3>
                      <span className="text-xs px-2 py-1 bg-yellow-50 text-yellow-700 rounded-full border border-yellow-100 italic">
                        {room.capacity}
                      </span>
                    </div>
                    <p className="text-sm text-slate-500 leading-relaxed">
                      {room.desc}
                    </p>
                  </div>
                  <ChevronRight className="w-5 h-5 text-yellow-200 self-center" />
                </div>
              </button>
            ))}
          </div>
        )}

        {/* Step 2: Date & Time */}
        {step === 2 && (
          <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-500">
            <button
              onClick={() => setStep(1)}
              className="text-yellow-600 text-sm flex items-center gap-1 hover:underline"
            >
              <ChevronLeft className="w-4 h-4" /> 返回重新選擇空間
            </button>

            <div className="bg-white p-6 rounded-3xl shadow-sm border border-yellow-50">
              <h2 className="text-lg font-semibold flex items-center gap-2 mb-4">
                <Calendar className="w-5 h-5 text-yellow-600" /> 選擇日期
                (週一公休)
              </h2>
              <input
                type="date"
                className="w-full p-4 rounded-2xl border-2 border-yellow-100 focus:border-yellow-400 outline-none transition-colors"
                onChange={(e) => {
                  const date = new Date(e.target.value);
                  if (date.getDay() === 1) {
                    alert("週一為公休日，請選擇其他日期");
                    e.target.value = "";
                  } else {
                    setSelectedDate(date);
                  }
                }}
              />
            </div>

            {selectedDate && (
              <div className="bg-white p-6 rounded-3xl shadow-sm border border-yellow-50 space-y-6">
                <h2 className="text-lg font-semibold flex items-center gap-2 mb-2">
                  <Clock className="w-5 h-5 text-yellow-600" /> 選擇時段
                </h2>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-slate-400 mb-1 block">
                      起始時間
                    </label>
                    <select
                      className="w-full p-3 rounded-xl border border-slate-100 bg-slate-50"
                      value={startTime}
                      onChange={(e) => setStartTime(e.target.value)}
                    >
                      <option value="">請選擇</option>
                      {timeSlots.map((t) => (
                        <option
                          key={`start-${t}`}
                          value={t}
                          disabled={isTimeOccupied(
                            selectedRoom,
                            selectedDate,
                            t
                          )}
                        >
                          {t}{" "}
                          {isTimeOccupied(selectedRoom, selectedDate, t)
                            ? "(已預約)"
                            : ""}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="text-xs text-slate-400 mb-1 block">
                      結束時間
                    </label>
                    <select
                      className="w-full p-3 rounded-xl border border-slate-100 bg-slate-50"
                      value={endTime}
                      onChange={(e) => setEndTime(e.target.value)}
                    >
                      <option value="">請選擇</option>
                      {timeSlots.map((t) => (
                        <option
                          key={`end-${t}`}
                          value={t}
                          disabled={isTimeOccupied(
                            selectedRoom,
                            selectedDate,
                            t
                          )}
                        >
                          {t}{" "}
                          {isTimeOccupied(selectedRoom, selectedDate, t)
                            ? "(已預約)"
                            : ""}
                        </option>
                      ))}
                      <option value="20:00">20:00</option>
                    </select>
                  </div>
                </div>
                <div className="p-3 bg-yellow-50 rounded-xl text-xs text-yellow-700 leading-relaxed border border-yellow-100">
                  ※ 最短租借時間為 1 小時。若該時段顯示「已預約」則無法點選。
                </div>
                <button
                  onClick={() => setStep(3)}
                  disabled={!startTime || !endTime}
                  className="w-full py-4 bg-yellow-400 text-white rounded-2xl font-bold shadow-lg shadow-yellow-200 disabled:opacity-50 hover:bg-yellow-500 transition-colors"
                >
                  確認時段並填寫資料
                </button>
              </div>
            )}
          </div>
        )}

        {/* Step 3: Info & Finish */}
        {step === 3 && (
          <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-500">
            <button
              onClick={() => setStep(2)}
              className="text-yellow-600 text-sm flex items-center gap-1 hover:underline"
            >
              <ChevronLeft className="w-4 h-4" /> 返回調整預約時間
            </button>

            <div className="bg-white p-6 rounded-3xl shadow-sm border border-yellow-50 space-y-4">
              <h2 className="text-lg font-semibold flex items-center gap-2 mb-2">
                <Box className="w-5 h-5 text-yellow-600" /> 器材借用
              </h2>
              <div className="grid grid-cols-2 gap-3">
                {equipments.map((item) => {
                  const isAvailable =
                    !item.limit || item.limit.includes(selectedRoom);
                  return (
                    <button
                      key={item.id}
                      disabled={!isAvailable}
                      onClick={() => {
                        if (selectedEquip.includes(item.name)) {
                          setSelectedEquip(
                            selectedEquip.filter((i) => i !== item.name)
                          );
                        } else {
                          setSelectedEquip([...selectedEquip, item.name]);
                        }
                      }}
                      className={`p-3 rounded-2xl text-sm border-2 transition-all flex items-center gap-2 ${
                        !isAvailable
                          ? "opacity-30 border-slate-100 bg-slate-50 cursor-not-allowed"
                          : selectedEquip.includes(item.name)
                          ? "border-yellow-400 bg-yellow-50 text-yellow-700"
                          : "border-slate-50 bg-white"
                      }`}
                    >
                      <div
                        className={`w-4 h-4 rounded-full border flex items-center justify-center ${
                          selectedEquip.includes(item.name)
                            ? "bg-yellow-400 border-yellow-400"
                            : "border-slate-300"
                        }`}
                      >
                        {selectedEquip.includes(item.name) && (
                          <CheckCircle2 className="w-3 h-3 text-white" />
                        )}
                      </div>
                      {item.name}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="bg-white p-6 rounded-3xl shadow-sm border border-yellow-50 space-y-4">
              <h2 className="text-lg font-semibold flex items-center gap-2 mb-2">
                <User className="w-5 h-5 text-yellow-600" /> 聯絡資訊
              </h2>
              <div className="space-y-4">
                <div>
                  <label className="text-xs text-slate-400 mb-1 block px-1">
                    您的姓名
                  </label>
                  <input
                    type="text"
                    placeholder="請輸入姓名"
                    className="w-full p-4 rounded-2xl border-2 border-slate-50 focus:border-yellow-400 outline-none transition-colors"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div>
                  <label className="text-xs text-slate-400 mb-1 block px-1">
                    電話號碼
                  </label>
                  <input
                    type="tel"
                    placeholder="請輸入手機號碼"
                    className="w-full p-4 rounded-2xl border-2 border-slate-50 focus:border-yellow-400 outline-none transition-colors"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="bg-yellow-100 p-6 rounded-3xl border border-yellow-200">
              <h3 className="font-bold text-yellow-900 mb-2">預約摘要</h3>
              <div className="text-sm space-y-1 text-yellow-800">
                <p>空間：{selectedRoom}</p>
                <p>日期：{selectedDate?.toLocaleDateString()}</p>
                <p>
                  時段：{startTime} - {endTime}
                </p>
                <p>
                  器材：
                  {selectedEquip.length > 0 ? selectedEquip.join("、") : "無"}
                </p>
              </div>
            </div>

            <button
              onClick={handleBooking}
              className="w-full py-5 bg-yellow-400 text-white rounded-3xl font-bold text-lg shadow-xl shadow-yellow-200 hover:bg-yellow-500 hover:scale-[1.02] active:scale-[0.98] transition-all flex items-center justify-center gap-2"
            >
              送出預約並連動官方 LINE
            </button>
          </div>
        )}
      </main>

      {/* Floating Elements */}
      <div className="fixed bottom-4 right-4 z-50 animate-bounce">
        <div className="bg-white px-4 py-2 rounded-full shadow-lg border border-yellow-100 text-xs font-medium text-yellow-600 flex items-center gap-2">
          <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />{" "}
          宇宙能量加載中
        </div>
      </div>
    </div>
  );
};

export default App;
